export function dataInRequest(params = {}) {
  return {
    type: '@auditoriaSistemas/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@auditoriaSistemas/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@auditoriaSistemas/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@auditoriaSistemas/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@auditoriaSistemas/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@auditoriaSistemas/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@auditoriaSistemas/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@auditoriaSistemas/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@auditoriaSistemas/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@auditoriaSistemas/RECORD_FILTERING',
    payload: { params },
  };
}
